import { AbstractControl } from '@angular/forms';

export function MustValue(control: AbstractControl) {
    if (Number(control.value) <= 0) {
        return { lessThanZero: true };
    }
    return null;
}
